import React from "react";
import { today } from 'AppReact';

const holder = {
  closeInputSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeInputSelector)
    }
  }
};

export default {
  'DateInputCell.RelativeWrapper.Selector': async ({ isOpen, containerRef, yearListRef, monthListRef, selectedYear, selectedDate, showCheckboxes }, _, internalStateSetter) => {
    if (isOpen || showCheckboxes) return;
    await internalStateSetter({ isOpen: true, left: null, top: null });

    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }

    let yearRef = yearListRef;
    if (!yearListRef) {
      yearRef = React.createRef(null)
      await internalStateSetter({ yearListRef: yearRef });
    }
    let monthRef = monthListRef;
    if (!monthListRef) {
      monthRef = React.createRef(null)
      await internalStateSetter({ monthListRef: monthRef });
    }

    let yearCenterPosition = yearRef?.current?.children?.[selectedYear - 2000]?.offsetLeft - (yearRef?.current?.getBoundingClientRect().width / 2);

    setTimeout(() => {
      monthRef?.current?.scrollTo({ top: selectedDate ? (302 * selectedDate.getMonth()) : (302 * today().getMonth()), behavior: 'smooth' });
    }, 500)

    let rect = newContainerRef?.current?.getBoundingClientRect();

    if (rect?.bottom && rect.bottom > 420) {
      await internalStateSetter({ top: 420 - rect.bottom })
    }
    if (rect?.right && window.innerWidth - rect.right < 302) {
      await internalStateSetter({ left: window.innerWidth - rect.right - 320 })
    }

    yearRef?.current?.scrollTo({ left: yearCenterPosition, behavior: 'smooth' });

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    document.addEventListener("mousedown", holder.closeInputSelector);
  },
  'DateInputCell.RelativeWrapper.DropdownWrapper.BorderWrapper.ListWrapper.YearList.Year': ({ year, monthListRef }, _, internalStateSetter) => {
    internalStateSetter({ selectedYear: year });
    monthListRef?.current?.children?.[0]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

  },
  'DateInputCell.RelativeWrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Month': ({ selectedDate }, outlet, internalStateSetter) => {
    outlet({ action: 'changeData', payload: selectedDate });
    internalStateSetter({ isOpen: false, selectedDate })
    document.removeEventListener("mousedown", holder.closeInputSelector);
  },
  'DateInputCell.RelativeWrapper.DropdownWrapper.BorderWrapper.ListWrapper.DeleteButton': ({ }, outlet, internalStateSetter) => {
    outlet({ action: 'changeData', payload: null });
    internalStateSetter({ isOpen: false, selectedDate: null });
    document.removeEventListener("mousedown", holder.closeInputSelector);
  }
}